import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/theme.css';
import { AuthProvider, ProtectedRoute } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';

import Overview from './pages/Overview';
import ODFlows from './pages/ODFlows';
import Predictions from './pages/Predictions';
import Deserts from './pages/Deserts';
import Accessibility from './pages/Accessibility';
import Profiling from './pages/Profiling';
import Anomalies from './pages/Anomalies';
import Events from './pages/Events';
import Optimizer from './pages/Optimizer';
import DigitalTwin from './pages/DigitalTwin';
import EventForecast from './pages/EventForecast';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Overview />} />
            <Route path="cartographie-od" element={<ODFlows />} />
            <Route path="previsions" element={<Predictions />} />
            <Route path="deserts" element={<Deserts />} />
            <Route path="accessibilite" element={<Accessibility />} />
            <Route path="profilage" element={<Profiling />} />
            <Route path="anomalies" element={<Anomalies />} />
            <Route path="evenements" element={<Events />} />
            <Route path="optimiseur" element={<Optimizer />} />
            <Route path="jumeau-numerique" element={<DigitalTwin />} />
            <Route path="prevision-evenementielle" element={<EventForecast />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
